import { mainApi } from '../../../api/mainApi';
import { AccessState } from '../../../types';
import { middlewareApi } from '../../middleware/middlewareApi';

export const moodleTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['MoodleAuth'],
});
// Define a service using a base URL and expected endpoints
export const moodleApi = moodleTags.injectEndpoints({
  endpoints: (builder) => ({
    authMoodle: builder.mutation<
      any,
      {
        profileId: number;
        userId: number;
        courseId: number;
      }
    >({
      queryFn: async ({ profileId, userId, courseId }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = profileId || currentProfile?.profileId;

          const { data } = await mainApi.post<any>(`/moodle/users/login`, {
            user_profile_id,
            user_id: userId,
            course_id: courseId,
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),

    goActivityMoodle: builder.mutation<
      any,
      {
        instance: number;
        userId: number | string;
        modulename: string;
      }
    >({
      queryFn: async ({ instance, userId, modulename }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.post<any>(`/moodle/courses/activity/${instance}`, {
            user_profile_id,
            user_id: userId,
            module: modulename,
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),

    //
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAuthMoodleMutation, useGoActivityMoodleMutation } = moodleApi;
